/**
 * @preserve Copyright 2013, Cardinal Path and DigitalInc.
 *
 * GAS - Google Analytics on Steroids
 * https://github.com/CardinalPath/gas
 *
 * @author Eduardo Cereto <eduardocereto@gmail.com>
 * Licensed under the GPLv3 license.
 *
 */

// Modified 2013-07-30 by Michael Harrison
// Added non-interaction flags to event tracking and added dc.js reference

(function (e, t) {
    if (!e) {
        // not in the client aka window
        return;
    }
    var global = e;
    try {
        if (Object.prototype.toString.call(global.process) === '[object process]') {
            return;
        }
    } catch(e) {}

    function p() {
        var e = this;
        e.version = "1.9", e._accounts = {}, e._accounts_length = 0, e._queue = r, e._default_tracker = "_gas1", e.gh = {}, e._hooks = {
            _addHook: [e._addHook]
        }, e.push(function () {
            e.gh = new n
        })
    }

    function d(e) {
        return e === _gas._default_tracker ? "" : e + "."
    }

    function v(t) {
        if (_gas.debug_mode) try {
            console.log(t)
        } catch (n) {}
        return e._gaq.push(t)
    }

    function m(e, t) {
        if (typeof e != "string") return !1;
        var n = e.split("?")[0];
        return n = n.split("."), n = n[n.length - 1], n && this.inArray(t, n) ? n : !1
    }

    function y(e) {
        while (e && e.nodeName !== "HTML") {
            if (e.nodeName === "FORM") break;
            e = e.parentNode
        }
        return e.nodeName === "FORM" ? e.name || e.id || "none" : "none"
    }

    function w(e) {
        _gas.push(["_trackEvent", this.tagName, e.type, this.currentSrc])
    }

    function N() {
        return e.innerHeight || h.clientHeight || i.body.clientHeight || 0
    }

    function C() {
        return e.pageYOffset || i.body.scrollTop || h.scrollTop || 0
    }

    function k() {
        return Math.max(i.body.scrollHeight || 0, h.scrollHeight || 0, i.body.offsetHeight || 0, h.offsetHeight || 0, i.body.clientHeight || 0, h.clientHeight || 0)
    }

    function L() {
        return (C() + N()) / k() * 100
    }

    function M(e) {
        A && clearTimeout(A);
        if (e === !0) {
            O = Math.max(L(), O);
            return
        }
        A = setTimeout(function () {
            O = Math.max(L(), O)
        }, 400)
    }

    function _() {
        M(!0), O = Math.floor(O);
        if (O <= 0 || O > 100) return;
        var e = (O > 10 ? 1 : 0) * (Math.floor((O - 1) / 10) * 10 + 1);
        e = String(e) + "-" + String(Math.ceil(O / 10) * 10), _gas.push(["_trackEvent", D.category, c, e, Math.floor(O), !0])
    }

    function P(t) {
        if ( !! this._maxScrollTracked) return;
        this._maxScrollTracked = !0, D = t || {}, D.category = D.category || "Max Scroll", this._addEventListener(e, "scroll", M), this._addEventListener(e, "beforeunload", _)
    }

    function j(e) {
        if (!this._multidomainTracked) {
            this._multidomainTracked = !0;
            var t = i.location.hostname,
                n = this,
                r, s, o, u = i.getElementsByTagName("a");
            e !== "now" && e !== "mousedown" && (e = "click");
            for (r = 0; r < u.length; r++) {
                o = u[r];
                if (l.call(o.href, "http") === 0) {
                    if (o.hostname == t || l.call(o.hostname, B) >= 0) continue;
                    for (s = 0; s < H.length; s++) l.call(o.hostname, H[s]) >= 0 && (e === "now" ? o.href = n.tracker._getLinkerUrl(o.href, _gas._allowAnchor) : e === "click" ? this._addEventListener(o, e, function (e) {
                        return _gas.push(["_link", this.href, _gas._allowAnchor]), e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1
                    }) : this._addEventListener(o, e, function () {
                        this.href = n.tracker._getLinkerUrl(this.href, _gas._allowAnchor)
                    }))
                }
            }
            return !1
        }
        return
    }

    function z(e) {
        R[e.player_id] || (R[e.player_id] = {}, R[e.player_id].timeTriggers = a.call(q));
        if (R[e.player_id].timeTriggers.length > 0 && e.data.percent * 100 >= R[e.player_id].timeTriggers[0]) {
            var t = R[e.player_id].timeTriggers.shift();
            _gas.push(["_trackEvent", "Vimeo Video", t + "%", U[e.player_id], 0, true])
        }
    }

    function W(e, t, n) {
        if (!n.contentWindow || !n.contentWindow.postMessage || !JSON) return !1;
        var r = n.getAttribute("src").split("?")[0],
            i = JSON.stringify({
                method: e,
                value: t
            });
        return n.contentWindow.postMessage(i, r), !0
    }

    function $(e) {
        if (l.call(e.origin, "//player.vimeo.com") > -1) {
            var t = JSON.parse(e.data);
            t.event === "ready" ? J.call(_gas.gh) : t.method ? t.method == "getVideoUrl" && (U[t.player_id] = t.value) : t.event === "playProgress" ? z(t) : _gas.push(["_trackEvent", V.category, t.event, U[t.player_id], 0, true])
        }
    }

    function J() {
        var t = i.getElementsByTagName("iframe"),
            n = 0,
            r, s, o, u = V.force,
            a = V.percentages;
        for (var f = 0; f < t.length; f++)
            if (l.call(t[f].src, "//player.vimeo.com") > -1) {
                r = "gas_vimeo_" + f, s = t[f].src, o = "?", l.call(s, "?") > -1 && (o = "&");
                if (l.call(s, "api=1") < 0) {
                    if (!u) continue;
                    s += o + "api=1&player_id=" + r
                } else l.call(s, "player_id=") < -1 && (s += o + "player_id=" + r);
                n++, t[f].id = r;
                if (t[f].src !== s) {
                    t[f].src = s;
                    break
                }
                W("getVideoUrl", "", t[f]), W("addEventListener", "play", t[f]), W("addEventListener", "pause", t[f]), W("addEventListener", "finish", t[f]), a && (q = a, W("addEventListener", "playProgress", t[f]))
            }
        n > 0 && X === !1 && (this._addEventListener(e, "message", $, !1), X = !0)
    }

    function Z(e) {
        if (Q && Q.length) {
            var t = e.getVideoData().video_id;
            Y[t] ? tt(e) : (Y[t] = {}, Y[t].timeTriggers = a.call(Q)), Y[t].timer = setTimeout(et, 1e3, e, t)
        }
    }

    function et(e, n) {
        if (Y[n] == t || Y[n].timeTriggers.length <= 0) return !1;
        var r = e.getCurrentTime() / e.getDuration() * 100;
        if (r >= Y[n].timeTriggers[0]) {
            var i = Y[n].timeTriggers.shift();
            _gas.push(["_trackEvent", G.category, i + "%", e.getVideoUrl(), 0, true])
        }
        Y[n].timer = setTimeout(et, 1e3, e, n)
    }

    function tt(e) {
        var t = e.getVideoData().video_id;
        Y[t] && Y[t].timer && (et(e, t), clearTimeout(Y[t].timer))
    }

    function nt(e) {
        var t = "";
        switch (e.data) {
            case 0:
                t = "finish", tt(e.target);
                break;
            case 1:
                t = "play", Z(e.target);
                break;
            case 2:
                t = "pause", tt(e.target)
        }
        t && _gas.push(["_trackEvent", G.category, t, e.target.getVideoUrl(), 0, true])
    }

    function rt(e) {
        _gas.push(["_trackEvent", G.category, "error (" + e.data + ")", e.target.getVideoUrl(), true])
    }

    function it() {
        var e = i.getElementsByTagName("object"),
            t, n, r, s = /(https?:\/\/www\.youtube(-nocookie)?\.com[^/]*).*\/v\/([^&?]+)/;
        for (var o = 0; o < e.length; o++) {
            t = e[o].getElementsByTagName("param");
            for (var u = 0; u < t.length; u++)
                if (t[u].name == "movie" && t[u].value) {
                    r = t[u].value.match(s), r && r[1] && r[3] && (n = i.createElement("iframe"), n.src = r[1] + "/embed/" + r[3] + "?enablejsapi=1", n.width = e[o].width, n.height = e[o].height, n.setAttribute("frameBorder", "0"), n.setAttribute("allowfullscreen", ""), e[o].parentNode.insertBefore(n, e[o]), e[o].parentNode.removeChild(e[o]), o--);
                    break
                }
        }
    }

    function st(t) {
        var n = t.force,
            r = t.percentages;
        if (n) try {
            it()
        } catch (s) {
            _gas.push(["_trackException", s, "GAS Error on youtube.js:_ytMigrateObjectEmbed"])
        }
        var o = [],
            u = i.getElementsByTagName("iframe");
        for (var a = 0; a < u.length; a++)
            if (l.call(u[a].src, "//www.youtube.com/embed") > -1) {
                if (l.call(u[a].src, "enablejsapi=1") < 0) {
                    if (!n) continue;
                    l.call(u[a].src, "?") < 0 ? u[a].src += "?enablejsapi=1" : u[a].src += "&enablejsapi=1"
                }
                o.push(u[a])
            }
        if (o.length > 0) {
            r && r.length && (Q = r), e.onYouTubePlayerAPIReady = function () {
                var t;
                for (var n = 0; n < o.length; n++) t = new e.YT.Player(o[n]), t.addEventListener("onStateChange", nt), t.addEventListener("onError", rt)
            };
            var f = i.createElement("script"),
                c = "http:";
            i.location.protocol === "https:" && (c = "https:"), f.src = c + "//www.youtube.com/player_api", f.type = "text/javascript", f.async = !0;
            var h = i.getElementsByTagName("script")[0];
            h.parentNode.insertBefore(f, h)
        }
    }
    var n = function () {
        this._setDummyTracker()
    };
    n.prototype._setDummyTracker = function () {
        if (!this.tracker) {
            var t = e._gat._getTrackers();
            t.length > 0 && (this.tracker = t[0])
        }
    }, n.prototype.inArray = function (e, t) {
        if (e && e.length)
            for (var n = 0; n < e.length; n++)
                if (e[n] === t) return !0;
        return !1
    }, n.prototype._sanitizeString = function (e, t) {
        return e = e.toLowerCase().replace(/^\ +/, "").replace(/\ +$/, "").replace(/\s+/g, "_").replace(/[\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, "a").replace(/[\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, "e").replace(/[\u00ed\u00ec\u00ee\u00ef]/g, "i").replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8\u00ba]/g, "o").replace(/[\u00fa\u00f9\u00fb\u00fc]/g, "u").replace(/[\u00e7\u00a2\u00a9]/g, "c"), t && (e = e.replace(/[^a-z0-9_-]/g, "_")), e.replace(/_+/g, "_")
    }, n.prototype._addEventListener = function (t, n, r, i) {
        var s = function (n) {
            if (!n || !n.target) n = e.event, n.target = n.srcElement;
            return r.call(t, n)
        };
        return t.addEventListener ? (t.addEventListener(n, s, !! i), !0) : t.attachEvent ? t.attachEvent("on" + n, s) : (n = "on" + n, typeof t[n] == "function" && (s = function (e, t) {
            return function () {
                e.apply(this, arguments), t.apply(this, arguments)
            }
        }(t[n], s)), t[n] = s, !0)
    }, n.prototype._liveEvent = function (e, t, n) {
        var r = this;
        e = e.toUpperCase(), e = e.split(","), r._addEventListener(i, t, function (t) {
            for (var i = t.target; i.nodeName !== "HTML"; i = i.parentNode)
                if (r.inArray(e, i.nodeName) || i.parentNode === null) break;
            i && r.inArray(e, i.nodeName) && n.call(i, t)
        }, !0)
    }, n.prototype._DOMReady = function (t) {
        function r() {
            if (r.done) return;
            r.done = !0, t.apply(n, arguments)
        }
        var n = this;
        if (/^(interactive|complete)/.test(i.readyState)) return r();
        this._addEventListener(i, "DOMContentLoaded", r, !1), this._addEventListener(e, "load", r, !1)
    }, e._gaq = e._gaq || [];
    var r = e._gas || [];
    if (r._accounts_length >= 0) return;
    var i = e.document,
        s = Object.prototype.toString,
        o = Object.prototype.hasOwnProperty,
        u = Array.prototype.push,
        a = Array.prototype.slice,
        f = String.prototype.trim,
        l = String.prototype.indexOf,
        c = i.location.href,
        h = i.documentElement;
    p.prototype._addHook = function (e, t) {
        return typeof e == "string" && typeof t == "function" && (typeof _gas._hooks[e] == "undefined" && (_gas._hooks[e] = []), _gas._hooks[e].push(t)), !1
    }, p.prototype._execute = function () {
        var e = a.call(arguments),
            n = this,
            r = e.shift(),
            i = !0,
            s, u, f, c, h, p = 0;
        if (typeof r == "function") return v(function (e, t) {
            return function () {
                e.call(t)
            }
        }(r, n.gh));
        if (typeof r == "object" && r.length > 0) {
            u = r.shift(), l.call(u, ".") >= 0 ? (c = u.split(".")[0], u = u.split(".")[1]) : c = t, f = n._hooks[u];
            if (f && f.length > 0)
                for (s = 0; s < f.length; s++) try {
                    h = f[s].apply(n.gh, r), h === !1 ? i = !1 : h && h.length > 0 && (r = h)
                } catch (m) {
                    u !== "_trackException" && n.push(["_trackException", m])
                }
            if (i === !1) return 1;
            if (u === "_setAccount") {
                for (s in n._accounts)
                    if (n._accounts[s] == r[0] && c === t) return 1;
                return c = c || "_gas" + String(n._accounts_length + 1), typeof n._accounts["_gas1"] == "undefined" && l.call(c, "_gas") != -1 && (c = "_gas1"), n._accounts[c] = r[0], n._accounts_length += 1, c = d(c), p = v([c + u, r[0]]), n.gh._setDummyTracker(), p
            }
            if (u === "_link" || u === "_linkByPost" || u === "_require" || u === "_anonymizeIp") return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            var g;
            if (c && n._accounts[c]) return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            if (n._accounts_length > 0) {
                for (s in n._accounts) o.call(n._accounts, s) && (g = d(s) + u, e = a.call(r), e.unshift(g), p += v(e));
                return p ? 1 : 0
            }
            return e = a.call(r), e.unshift(u), v(e)
        }
    }, p.prototype.push = function () {
        var t = this,
            n = a.call(arguments);
        for (var r = 0; r < n.length; r++)(function (t, n) {
            e._gaq.push(function () {
                n._execute.call(n, t)
            })
        })(n[r], t)
    }, e._gas = _gas = new p, _gas.push(["_addHook", "_trackException",
        function (e, t) {
            return _gas.push(["_trackEvent", "Exception " + (e.name || "Error"), t || e.message || e, c, 0, true]), !1
        }
    ]), _gas.push(["_addHook", "_setDebug",
        function (e) {
            _gas.debug_mode = !! e
        }
    ]), _gas.push(["_addHook", "_popHook",
        function (e) {
            var t = _gas._hooks[e];
            return t && t.pop && t.pop(), !1
        }
    ]), _gas.push(["_addHook", "_gasSetDefaultTracker",
        function (e) {
            return _gas._default_tracker = e, !1
        }
    ]), _gas.push(["_addHook", "_trackPageview",
        function () {
            var e = a.call(arguments);
            return e.length >= 2 && typeof e[0] == "string" && typeof e[1] == "string" ? [{
                page: e[0],
                title: e[1]
            }] : e
        }
    ]);
    var g = function (e) {
        var t = this;
        if (!t._downloadTracked) {
            t._downloadTracked = !0, e ? typeof e == "string" ? e = {
                extensions: e.split(",")
            } : e.length >= 1 && (e = {
                extensions: e
            }) : e = {
                extensions: []
            }, e.category = e.category || "Download";
            var n = "xls,xlsx,doc,docx,ppt,pptx,pdf,txt,zip";
            return n += ",rar,7z,exe,wma,mov,avi,wmv,mp3,csv,tsv", n = n.split(","), e.extensions = e.extensions.concat(n), t._liveEvent("a", "mousedown", function (n) {
                var r = this;
                if (r.href) {
                    var i = m.call(t, r.href, e.extensions);
                    i && _gas.push(["_trackEvent", e.category, i, r.href])
                }
            }), !1
        }
        return
    };
    _gas.push(["_addHook", "_trackDownloads", g]), _gas.push(["_addHook", "_trackEvent",
        function () {
            var e = a.call(arguments);
            return e[3] && (e[3] = (e[3] < 0 ? 0 : Math.round(e[3])) || 0), e
        }
    ]);
    var b = function (e) {
        if ( !! this._formTracked) return;
        this._formTracked = !0;
        var t = this;
        typeof e != "object" && (e = {}), e.category = e.category || "Form Tracking";
        var n = function (t) {
            var n = t.target,
                r = n.name || n.id || n.type || n.nodeName,
                i = y(n),
                s = "form (" + i + ")",
                o = r + " (" + t.type + ")";
            _gas.push(["_trackEvent", e.category, s, o, 0, true])
        };
        t._DOMReady(function () {
            var e = ["input", "select", "textarea", "hidden"],
                r = ["form"],
                s = [],
                o, u;
            for (o = 0; o < e.length; o++) {
                s = i.getElementsByTagName(e[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "change", n)
            }
            for (o = 0; o < r.length; o++) {
                s = i.getElementsByTagName(r[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "submit", n)
            }
        })
    };
    _gas.push(["_addHook", "_trackForms", b]);
    var E = function (e) {
        var t = this;
        t._liveEvent(e, "play", w), t._liveEvent(e, "pause", w), t._liveEvent(e, "ended", w)
    }, S = function () {
        if ( !! this._videoTracked) return;
        this._videoTracked = !0, E.call(this, "video")
    }, x = function () {
        if ( !! this._audioTracked) return;
        this._audioTracked = !0, E.call(this, "audio")
    };
    _gas.push(["_addHook", "_trackVideo", S]), _gas.push(["_addHook", "_trackAudio", x]);
    var T = function (e) {
        if (!this._mailtoTracked) return this._mailtoTracked = !0, e || (e = {}), e.category = e.category || "Mailto", this._liveEvent("a", "mousedown", function (t) {
            var n = t.target;
            n && n.href && n.href.toLowerCase && l.call(n.href.toLowerCase(), "mailto:") === 0 && _gas.push(["_trackEvent", e.category, n.href.substr(7), undefined, 0, true])
        }), !1;
        return
    };
    _gas.push(["_addHook", "_trackMailto", T]);
    var A = null,
        O = 0,
        D;
    _gas.push(["_addHook", "_trackMaxScroll", P]), _gas._allowAnchor = !1, _gas.push(["_addHook", "_setAllowAnchor",
        function (e) {
            _gas._allowAnchor = !! e
        }
    ]), _gas.push(["_addHook", "_link",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]), _gas.push(["_addHook", "_linkByPost",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]);
    var H = [],
        B = t;
    _gas.push(["_addHook", "_setDomainName",
        function (e) {
            if (l.call("." + i.location.hostname, e) < 0) return H.push(e), !1;
            B = e
        }
    ]), _gas.push(["_addHook", "_addExternalDomainName",
        function (e) {
            return H.push(e), !1
        }
    ]);
    var F = function () {
        var e = this,
            t = a.call(arguments);
        e._DOMReady(function () {
            j.apply(e, t)
        })
    };
    _gas.push(["_addHook", "_setMultiDomain", F]);
    var I = function (e) {
        if ( !! this._outboundTracked) return;
        this._outboundTracked = !0;
        var t = this;
        e || (e = {}), e.category = e.category || "Outbound", t._liveEvent("a", "mousedown", function (t) {
            var n = this;
            if ((n.protocol == "http:" || n.protocol == "https:") && l.call(n.hostname, i.location.hostname) === -1) {
                var r = n.pathname + n.search + "",
                    s = l.call(r, "__utm");
                s !== -1 && (r = r.substring(0, s)), _gas.push(["_trackEvent", e.category, n.hostname, r, 0, true])
            }
        })
    };
    _gas.push(["_addHook", "_trackOutboundLinks", I]);
    var q = [],
        R = {}, U = {}, X = !1,
        V, K = function (e) {
            var t = this;
            if (typeof e == "boolean" || e === "force") e = {
                force: !! e
            };
            return e = e || {}, e.category = e.category || "Vimeo Video", e.percentages = e.percentages || [], e.force = e.force || !1, V = e, t._DOMReady(function () {
                J.call(t)
            }), !1
        };
    _gas.push(["_addHook", "_trackVimeo", K]);
    var Q = [],
        G, Y = {}, ot = function (e) {
            var t = a.call(arguments);
            t[0] && (typeof t[0] == "boolean" || t[0] === "force") && (e = {
                force: !! t[0]
            }, t[1] && t[1].length && (e.percentages = t[1])), e = e || {}, e.force = e.force || !1, e.category = e.category || "YouTube Video", e.percentages = e.percentages || [], G = e;
            var n = this;
            return n._DOMReady(function () {
                st.call(n, e)
            }), !1
        };
    _gas.push(["_addHook", "_trackYoutube", ot]);
    while (_gas._queue.length > 0) _gas.push(_gas._queue.shift());
    global._gaq && global._gaq.length >= 0 && function () {
        var e = i.createElement("script");
        e.type = "text/javascript", e.async = !0, e.src = ("https:" == i.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
        if (window.document.body) {
            // This is used by the unit test
            window.document.body.appendChild(e, t);
        } else {
            // Removing this causes a JS error since document.body may not be defined at the time it's called
            var t = i.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t);
        }
    }()
})(typeof window !== 'undefined' ? window : null);



//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-gas/index.js
// module id = ./node_modules/dibs-gas/index.js
// module chunks = 4